import React from 'react';
import { ProgressBar } from '../ProgressBar/ProgressBar';
import './LabelledProgress.css';
import { sum } from 'lodash';

interface Value {
  value: number;
  label?: string;
  displayValue?: string;
  color?: string;
}

interface Props {
  values: Value[];
}

export const LabelledProgress = ({ values }: Props): JSX.Element => {
  const progress = (values[0]?.value ?? 0) / sum(values.map((e) => e.value));
  return (
    <div className="labelled-progress__progress-wrapper">
      <div className="labelled-progress__progress-label">
        {values.map((value, index) => (
          <div
            key={value.label ?? index}
            className="labelled-progress__label-component"
            style={{
              flex: `${value.value}`,
            }}
          >
            {value.displayValue ?? value.value}
            <span>{value.label}</span>
          </div>
        ))}
      </div>
      <ProgressBar size="big" progress={progress} baseColor={values[1]?.color ?? 'var(--color-tint)'} />
    </div>
  );
};
